module.exports = __webpack_public_path__ + "img/1529902019.88c96940.jpg";